import { render, staticRenderFns } from "./SourceAccountingSummaryTab.vue?vue&type=template&id=25ce19ff&"
import script from "./SourceAccountingSummaryTab.vue?vue&type=script&lang=js&"
export * from "./SourceAccountingSummaryTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports